<template>
<div class="top">
      <nav>
        <ul>
          <li><a target="_blank" href="http://www.fangchan.com">中房网首页</a></li>
          <li><a target="_blank" href="http://www.fangchan.com/news/">新闻资讯</a></li>
          <li><a target="_blank" href="http://www.fangchan.com/data/">数据研究</a></li>
          <li><a target="_blank" href="http://www.fangchan.com/industry/">行业测评</a></li>
        </ul>
      </nav>
    <div class="main">
      <header>
        <img src="../assets/images/logo.png">
        <h1 class="title">中国房地产测评系列榜单</h1>
        <small class="search-small">中国房地产业协会、中国房地产测评中心发布</small>
      </header>
      <div class="search-main">
          <el-input class="search-input" placeholder="请输入企业名称" v-model="qname" @keyup.enter.native="handleIconClick" @focus="handleFocus(qname)" @blur="handleBlur"></el-input>
          <el-button class="search-button" type="primary" @click="handleIconClick">查询</el-button>
          <div class="footer-link">
          </div>
      </div>
      <ul class="search-list" v-if="resultData.length>0 && show">
        <li class="cell" v-for="(o,index) in resultData" :key="index">
          <a target="_blank" href="javascript:;" @mousedown="gotoResult(o)">{{o}}</a>
          <!-- <router-link target="_blank" :to="{ path: 'search/result', query:{qname: o}}" @mousedown="doThat(o)">{{o}}</router-link> -->
        </li>
      </ul>
    </div>

    <div class="join-us">
      <a href="http://www.fangchan.com/zt/cp/index.html" target="_blank"><img class="max" src="../assets/images/join-us.png" width="125" height="60" /></a>
      <a href="http://www.fangchan.com/zt/cp/index.html" target="_blank"><img class="min" src="../assets/images/join-us-small.png" width="125" height="60" /></a>
    </div>
</div>
</template>
<script>
export default{
  name: 'search',
  data (){
    return {
        msg: '',
        qname: '',
        resultData: [],
        tableData:[],
        show: false
      }
  },
  mounted: function(){
    var that = this;
    that.setHeight();
    $(window).resize(function(){
      that.setHeight();
    });
    this.$nextTick(function () {
        
    });
  },
  watch: {
    qname:{
      handler:function(val,oldval){
        console.log(val);
          if(val){
            this.$http.get('api/search/getkeyword', {params : {qname: val}}).then(
              response => {
                this.show = true;
                this.resultData = response.body;
              },
              response => {

              }
            )
          }else{
            this.resultData.length = 0;
          }
      },
      deep:true//对象内部的属性监听，也叫深度监听
    }
  },
  methods: {
    handleIconClick () {
      this.$router.push({path: 'search/result', query: {qname: this.qname}});
    },
    handleFocus (val) {
      this.$http.get('api/search/getkeyword', {params : {qname: val}}).then(
        response => {
          this.show = true;
          this.resultData = response.body;
        },
        response => {

        }
      )
    },
    handleBlur () {
      this.show = false;
    },
    gotoResult (value) {
      var url = '/#/search/result?qname='+value;
      window.open(url);
    },
    setHeight (){
      var width = window.innerWidth;
      if(width < 1023){
        var height = window.innerHeight - 100;
        $('.join-us').css('bottom', '10px');
        $('.top').height(height);
      }else{
        var height = window.innerHeight - 210;
        if(window.innerHeight > 800){
          $('.top').height(height);
          $('.join-us').css('bottom', '170px');
        }else{
          $('.top').height(window.innerHeight);
          $('.join-us').css('bottom', '140px');
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Search.vue